import { render, staticRenderFns } from "./ExcusarMagistrado.vue?vue&type=template&id=23ba4f4f&"
import script from "./ExcusarMagistrado.vue?vue&type=script&lang=js&"
export * from "./ExcusarMagistrado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports